module.exports = __webpack_public_path__ + "img/icon-certified.5b8d170c.svg";